module.exports = __webpack_public_path__ + "common/icon-arrow-right-b9cdaef31f8f74b2a6dd78ae947b1046.svg";